import React from "react";

import ArticleCarousel from "../ArticleCarousel";

export default function RelatedContent(props){
    const {
        related_article = [], 
        media_type = "", 
        related_article_view_all_button_label = null, 
        related_article_view_all_button_link = null,
        related_article_autoplay = false,
        related_article_autoplay_delay = 5000,
        related_article_title = null,
    } = props;


    return (
        (related_article || []).length > 0 && (
            <ArticleCarousel 
                title={related_article_title !== null && related_article_title !== "" ? related_article_title : "Related content"}
                article={related_article} 
                wrap_articles={0} 
                media_type={media_type} 
                autoplay={related_article_autoplay}
                delay={related_article_autoplay_delay}
                view_all_button_label={related_article_view_all_button_label} 
                view_all_button_link={related_article_view_all_button_link} 
            />
        )
    )
}